import { TEntityListResponse, TPermissionSummaryResBody } from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TPermissionsClient = {
  list(
    limit: number,
    page: number,
    roleId: string
  ): Promise<TEntityListResponse<'permission', TPermissionSummaryResBody> | undefined>;
};

function PermissionsClient(apiClient: TAPIClient): TPermissionsClient {
  return {
    async list(
      limit: number,
      page: number,
      roleId: string
    ): Promise<TEntityListResponse<'permission', TPermissionSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'permission', TPermissionSummaryResBody>>(
        `/permissions?limit=${limit}&page=${page}&filter[role_id]=${roleId}`
      );

      if (data && data.type !== 'permission') {
        throw new Error('Invalid entity type received, expected: permission, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TPermissionsClient, PermissionsClient };
